import { render, staticRenderFns } from "./SensorsDataPage.vue?vue&type=template&id=e0db3452&scoped=true&"
import script from "./SensorsDataPage.vue?vue&type=script&lang=js&"
export * from "./SensorsDataPage.vue?vue&type=script&lang=js&"
import style0 from "./SensorsDataPage.vue?vue&type=style&index=0&id=e0db3452&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0db3452",
  null
  
)

export default component.exports